import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { usePendingRequests } from './PendingRequests/usePendingRequests';
import PendingFiltersBar from './PendingRequests/PendingFiltersBar';
import PendingBookingCard from './PendingRequests/PendingBookingCard';

export default function PendingRequests() {
  const f = usePendingRequests();

  return (
    <div data-testid="pending-requests-page">
      <h1 className="text-4xl font-black font-heading uppercase mb-6">Pending Requests</h1>

      <PendingFiltersBar
        locationsList={f.locationsList}
        locationFilter={f.locationFilter} setLocationFilter={f.setLocationFilter}
        phoneFilter={f.phoneFilter} setPhoneFilter={f.setPhoneFilter}
        bookingRefFilter={f.bookingRefFilter} setBookingRefFilter={f.setBookingRefFilter}
        emailFilter={f.emailFilter} setEmailFilter={f.setEmailFilter}
        dateFrom={f.dateFrom} setDateFrom={f.setDateFrom}
        dateTo={f.dateTo} setDateTo={f.setDateTo}
        applyDateFilters={f.applyDateFilters}
        clearFilters={f.clearFilters}
      />

      {f.loading ? (
        <div className="text-center py-8 text-muted-foreground">Loading...</div>
      ) : f.bookings.length === 0 ? (
        <Card className="p-8 text-center">
          <p className="text-muted-foreground">No pending requests</p>
        </Card>
      ) : f.filteredBookings.length === 0 ? (
        <Card className="p-8 text-center">
          <p className="text-muted-foreground">No bookings match your filters</p>
          {(f.locationFilter !== 'all' || f.phoneFilter) && (
            <Button variant="link" onClick={f.clearFilters} className="mt-2">
              Clear filters
            </Button>
          )}
        </Card>
      ) : (
        <div className="space-y-4">
          <div className="text-sm text-muted-foreground mb-2">
            Showing {f.filteredBookings.length} of {f.bookings.length} pending request(s)
          </div>

          {f.filteredBookings.map((booking) => (
            <PendingBookingCard
              key={booking.id}
              booking={booking}
              location={f.locations[booking.location_id]}
              cancelling={f.cancelling}
              onCancelBooking={f.handleCancelBooking}
              isDialogOpen={f.isDialogOpen}
              setIsDialogOpen={f.setIsDialogOpen}
              selectedBooking={f.selectedBooking}
              courtsAssigned={f.courtsAssigned}
              availableCourts={f.availableCourts}
              assignedCourtNumbers={f.assignedCourtNumbers}
              getAvailableCourtNumbersForDropdown={f.getAvailableCourtNumbersForDropdown}
              onUpdateCourt={f.updateCourtNumber}
              discountType={f.discountType}
              setDiscountType={f.setDiscountType}
              discountValue={f.discountValue}
              setDiscountValue={f.setDiscountValue}
              discountReason={f.discountReason}
              setDiscountReason={f.setDiscountReason}
              onAssignClick={f.handleAssignClick}
              onConfirmAssign={f.handleAssignCourts}
            />
          ))}
        </div>
      )}
    </div>
  );
}
